module.exports = __webpack_public_path__ + "img/sweden.8425fb75.svg";